import React from "react";
import PropTypes from 'prop-types';
import { useStaticQuery, graphql } from 'gatsby';

const MetaHead = ({title, description, image}) => {

    const { site } = useStaticQuery(
        graphql`
          query {
            site {
                siteMetadata {
                    siteUrl
                }
            }
          }
        `,
        );

    const pathname = typeof window !== 'undefined' ? window.location.pathname : '';

    // console.log('Description', description.split(/\r?\n/).filter(line => line.trim() !== '').join('\n'));

    const removeEmptyLines = str => str.split(/\r?\n/).filter(line => line.trim() !== '').join('\n').split('.').filter((s, idx) => idx < 2).join('.');
    
    return (
        <>
            <title>{title}</title>
            <meta name="description" content={description ? removeEmptyLines(description) : ''}/>
            <meta name="image" content={image}/>
            <meta property="og:title" content={title} />
            <meta property="og:type" content="website" />
            <meta property="og:description" content={description ? removeEmptyLines(description) : ''} />
            <meta property="og:url" content={`${site.siteMetadata?.siteUrl}${pathname}`} />
            <meta property="og:image" content={image} />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description ? removeEmptyLines(description) : ''} />
            <meta name="twitter:image" content={image} />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@dataschooluk" />
            <meta property="og:site_name" content="The Data School powered by The Information Lab"></meta>
        </>
)}

MetaHead.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string,
};

export default MetaHead;